var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card-alert"},[_c('b-card-text',{staticClass:"my-1 help-text text-muted"},[_c('alert-circle-icon',{attrs:{"size":"21"}}),_vm._v(" "+_vm._s(_vm.$t('dashboard.notExistsNearlyEndingDocuments'))+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }